import React from 'react';
// import Schedule from './schedule'
// import {wsTrans} from '../../utils/utils'
import DoserValves from "./DoserValves";
import styles from './pearlDoser.module.css'
import LoadingSpinner from '../loadingSpinner'
import { loadChannelInfo, loadZoneInfo, getChannelNames } from "../C18AiUtils";
import {getParamId2,getPearlUsed} from '../../utils/utils'
import {cl,globs,constant,getTime,calcFwVers,
} from '../../../components/utils/utils';

class DoserValvesParent extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      loaded:true,
    }
  }

  componentDidMount=()=>{
    this.loadInfo()
  }

  loadInfo=async()=>{
    let equipNameId=getParamId2(1900,
      "configuration_channels","channelName")
    let equipTypeId=getParamId2(1900,
      "configuration_channels","channelType")
    let siteId=globs.userData.session.siteId
    await loadZoneInfo(siteId)
    let now=getTime()
    let zones=globs.zonesInfo.info.filter(z=>(z.siteId==siteId)&&((now-z.updateTime)<300))
//     cl(zones)
    let {mode}=this.props
//     cl(mode)
    if(mode!="simple"){// don't show <1.18.2 zones
      let gateways=globs.gatewaysInfo.info.filter(gw=>(gw.siteId==siteId))
      zones=zones.filter(z=>{
        let gw=gateways.find(g=>g.gatewayId==z.gatewayId)
        let fw=calcFwVers(gw.fwVersion)
        return fw>=11802
      })
//       cl(zones)
    }


    let zoneNames=[]
    zones.forEach(z=>zoneNames[z.siteZoneIndex]=z.zoneName)
    let gotChans={}// chans with xBoards there
//     cl(zones)
    zones.forEach(z=>{
      let pu=getPearlUsed(z.siteZoneIndex)
      if(!gotChans[z.siteZoneIndex]){gotChans[z.siteZoneIndex]={}}
      pu.forEach(p=>{gotChans[z.siteZoneIndex][p.chInd]=1})
    })
//     cl(gotChans)
    await loadChannelInfo(siteId)
    let chanNames0=getChannelNames()
    cl(chanNames0)
    let chanNames=[]
    Object.keys(chanNames0).forEach(z=>{
      let chans=[]
      Object.keys(chanNames0[z]).forEach(c=>{
//         cl(z,c,chanNames0[z][c][equipNameId],gotChans[z]?.[c])
        if((chanNames0[z][c][equipTypeId]==constant.EQ_IRR)&&(gotChans[z]?.[c])){
          chans[c]=chanNames0[z][c][equipNameId]
        }
      })
      chanNames[z]=chans
    })
//     cl(zoneNames)
    cl(chanNames)
    this.setState({zoneNames:zoneNames,channelNames:chanNames,selKeys:[]})
  }

  onValvesChange=(msg)=>{
//     cl(msg)
    switch(msg.type){
      case "selKeys":
        this.props.onChange({type:"valves",val:msg.val})
//         this.setState({selKeys:msg.val})
        break
      default:
        break
    }
  }

  render(){
    let st=this.state
//     cl(st)
    if(st.loaded){
      return(
        <div className={styles.pearlDoser}
        style={{padding:20}}
          onMouseDown={this.pageMouseDown}
        >
          <DoserValves
            zoneNames={st.zoneNames}
            channelNames={st.channelNames}
            selKeys={this.props.valves}
            onChange={this.onValvesChange}
          />

        </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
  }
}

export default DoserValvesParent;
